import { useEffect, useState } from "react";
import { http } from "../../lib/api";
import { Card } from "../kit/Kit";
import { CAT, inp, Vacio } from "./common";
import { Detalle } from "./Detalle";
import { Fila } from "./Eventos";
import { SesionCard } from "./Sesiones";

export const Usuario = ({ usuarios, esMaster }) => {
  const [uid, setUid] = useState("");
  const [d, setD] = useState(null);
  const [sel, setSel] = useState(null);
  useEffect(() => { if (uid) http.get(`/audit/usuario/${uid}`).then((r) => setD(r.data)); else setD(null); }, [uid]);
  return (
    <div className="space-y-4" data-testid="bit-usuario">
      <Card title="Expediente del usuario" subtitle="Línea de tiempo de todas sus sesiones y acciones">
        <select value={uid} onChange={(e) => setUid(e.target.value)} className={`${inp} max-w-md`} data-testid="bit-usuario-select">
          <option value="">Elige un usuario…</option>{usuarios.map((u) => <option key={u.id} value={u.id}>{u.name} · {u.email}</option>)}</select>
        {d && <div className="mt-4 flex flex-wrap gap-2" data-testid="bit-usuario-resumen">{Object.entries(d.resumen).map(([k, v]) => (
          <span key={k} className="rounded-full border border-[#E2DDD5] px-3 py-1 text-xs">{CAT[k] || k}: <b>{v}</b></span>))}</div>}
      </Card>
      {d && <div className="grid gap-4 xl:grid-cols-[2fr_3fr]">
        <Card title={`Sesiones (${d.sesiones.length})`}>{d.sesiones.length ? d.sesiones.map((s) => <SesionCard key={s.id} s={s} />) : <Vacio />}</Card>
        <Card title={`Actividad (${d.eventos.length})`} testid="bit-usuario-timeline">{d.eventos.length ? d.eventos.map((e) => <Fila key={e.seq} e={e} onClick={() => setSel(e)} />) : <Vacio />}</Card>
      </div>}
      <Detalle e={sel} onClose={() => setSel(null)} esMaster={esMaster} onDone={() => setSel(null)} />
    </div>
  );
};
